var render, staticRenderFns
import script from "./MultiTab.vue?vue&type=script&lang=js"
export * from "./MultiTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a077731d30b9c08d467996619bc6621/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports